<script lang="ts">
	import type { UploadedFile } from "../../../../core/schema/UploadedFile.js";
	import DynamicVideoInner from "./DynamicVideoInner.svelte";
	import { getGlobalSettings } from "../../getGlobalSettings.js";

	export let video: UploadedFile;
	export let containerClass = "";
	export { containerClass as class };
	export let width: number;
	export let height: number;
	export let loop = true;
	export let autoplay = true;
	export let videoClass = "";
	export let icon = false;
	export let lightboxId: string | undefined = undefined;
	export let alt = "";

	const bucket = "storage";

	const { STORAGE_URL, UPLOAD_URL } = getGlobalSettings();

	$: bucketUrl = {
		storage: STORAGE_URL,
		upload: UPLOAD_URL,
	}[bucket];
</script>

{#if lightboxId}
	<a
		class="group relative z-50 block {containerClass}"
		href="{bucketUrl}/{video.path}"
		data-fslightbox={lightboxId}
		data-type="video"
		data-caption={alt}
		on:mouseover
		on:focus
		on:mouseout
		on:blur
	>
		<DynamicVideoInner {video} {width} {height} {loop} {autoplay} {videoClass} {icon} />
	</a>
{:else}
	<div
		class="{containerClass} group relative z-50"
		on:mouseover
		on:focus
		on:mouseout
		on:blur
		role="button"
		tabindex="0"
	>
		<DynamicVideoInner {video} {width} {height} {loop} {autoplay} {videoClass} {icon} />
	</div>
{/if}
